import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiLock,FiX,FiEye,FiEyeOff} = FiIcons;

function MaintenanceAdmin({maintenanceMode,onToggle,onClose}) {
  return (
    <div className="maintenance-admin-backdrop" onClick={onClose}>
      <aside className="maintenance-admin" onClick={(event) => event.stopPropagation()}>
        <button className="maintenance-admin-close" onClick={onClose} aria-label="Close admin controls">
          <SafeIcon icon={FiX} />
        </button>
        <SafeIcon icon={FiLock} className="admin-lock-icon" />
        <span className="eyebrow">Google Sheets admin controls</span>
        <h2>Site visibility</h2>
        <p>
          This switch is shared through the Google Sheets Configuration tab.
          Anyone with access to this control can change the site visibility.
        </p>
        <button className={maintenanceMode ? 'maintenance-toggle is-on' : 'maintenance-toggle'} onClick={onToggle}>
          <span className="toggle-track"><span /></span>
          <span>{maintenanceMode ? 'Coming soon page is active' : 'Live site is active'}</span>
          <SafeIcon icon={maintenanceMode ? FiEyeOff : FiEye} />
        </button>
        <small>Toggle maintenance mode and refresh the page to preview the visitor experience.</small>
      </aside>
    </div>
  );
}

export default MaintenanceAdmin;